// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonalCard_wrapper__NMQDn","description":"PersonalCard_description__FVVeS","certificates":"PersonalCard_certificates__0WaA9","photo":"PersonalCard_photo__0H6Pu"};